//Please add the language resource
const salesApprove = {
  nodeName: '审批节点',
  approveUserName: '审批人',
  approveTime: '处理时间',
  approveComment: '审批意见',
  approveStatusName: '审批结果',
  msg:{
  }
};
export default salesApprove



// WEBPACK FOOTER //
// ./src/page/order/salesApprove/lang/salesApprove.en.js